<template>
  <p class="lead">
    <stemble-latex :content="invalidFeedback"></stemble-latex>
  </p>
</template>

<script>
import StembleLatex from '@/tasks/components/StembleLatex';

export default {
  name: 'InvalidFeedback',
  components: {
    StembleLatex,
  },
  props: {
    invalidFeedback: {
      required: true,
    },
  },
};
</script>
